@if (lockText) {
  <div class="login-lock-hint" role="alert">
    {{ lockText }}
  </div>
}
